import {
  Component,
  computed,
  effect,
  inject,
  model,
  signal,
  viewChild,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ThemeService } from '../../utils/services/theme.service';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';
import { LanguageService } from '../../utils/services/language.service';
import { Language } from '../../schemas/language';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../alert/alert.component';
import { User } from '../../schemas/user';
import { BossAuthService } from '../../services/boss-auth.service';
import { DirectusFileSchema } from '../../schemas/business';
import { ImageUploaderComponent } from '../image-uploader/image-uploader.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'qwiko-dashboard-top-nav',
  imports: [
    CommonModule,
    TranslocoModule,
    FormsModule,
    AlertComponent,
    ImageUploaderComponent,
  ],
  templateUrl: './dashboard-top-nav.component.html',
  styleUrl: './dashboard-top-nav.component.scss',
})
export class DashboardTopNavComponent {
  private bossAuthService = inject(BossAuthService);
  private themeService = inject(ThemeService);
  public languageService = inject(LanguageService);
  env = environment;
  // private transactionService = inject(TransactionService);
  private userService = inject(UserService);
  user = this.userService.user;
  userEffect = effect(() => {
    const names = this.user()?.names?.split(' ');
    this.firstName.set(names?.[0]!);
    this.lastName.set(names?.[1]!);
    this.email.set(this.user()?.email!);
    this.userImage.set(this.user()?.user_image! as DirectusFileSchema);
  });

  user_profile_collapse = signal<string>('');

  firstName = signal<string>('');
  lastName = signal<string>('');
  email = signal<string>('');
  userImage = signal<DirectusFileSchema | null>(null);
  userImageLink = computed(() => {
    return this.userImage() !== null
      ? `${this.env.apiUrl}/assets/${this.userImage()!.id}/${this.userImage()!.filename_disk}`
      : '';
  });

  currentTheme = computed(() => {
    return this.themeService.currentTheme();
  });

  chosenTheme = computed(() => {
    return this.themeService.chosenTheme();
  });

  loading = signal<boolean>(false);
  loadingEffect = effect(() => {
    if (!this.loading()) {
      this.loadingTarget.set(null);
    }
  });
  loadingTarget = signal<string | null>(null);
  isEdit = signal<boolean>(false);

  sideNavIsOpen = model<boolean>(true);

  isUserSettings = signal<boolean>(true);
  isChangePassword = signal<boolean>(false);
  passwordOld = signal<string>('');
  password = signal<string>('');
  passwordRepeat = signal<string>('');

  async loadUserData() {
    this.loading.set(true);
    await this.userService.getUser();
    this.loading.set(false);
  }
  async toggleTheme() {
    this.loading.set(true);
    this.loadingTarget.set('theme');
    await this.userService.toggleTheme();
    this.loading.set(false);
  }

  toggleChangePassword() {
    this.isUserSettings.set(!this.isUserSettings());
    this.isChangePassword.set(!this.isChangePassword());
    this.isEdit.set(false);
  }

  toggleEdit() {
    this.isEdit.set(!this.isEdit());
  }

  async updateUserProfile() {
    this.loading.set(true);

    const user: User = {
      first_name: this.firstName(),
      last_name: this.lastName(),
      names: `${this.firstName()} ${this.lastName()}`,
    };

    await this.userService.updateUser(user);
    // this.userService.changeUserPassword();
    this.loading.set(false);
    this.isEdit.set(false);
  }

  async changeUserPassword() {
    this.loading.set(true);

    await new Promise((resolve) => setTimeout(resolve, 2000));
    // this.userService.changeUserPassword();
    this.loading.set(false);
  }

  async setLanguage(selectedLanguage: any) {
    this.loading.set(true);
    const language = JSON.parse(selectedLanguage) as Language;
    await this.userService.toggleLanguage(language);
    // await this.transactionService.getTransactions();
    this.loading.set(false);
  }

  signOut() {
    this.loading.set(true);
    this.loadingTarget.set('signOut');
    this.bossAuthService.signOut();
  }

  toggleSideNav() {
    this.sideNavIsOpen.set(!this.sideNavIsOpen());
  }

  async resetStates() {
    // this.firstName.set('');
    // this.lastName.set('');
    // this.email.set('');
    this.loading.set(false);
    this.isEdit.set(false);
    this.isUserSettings.set(true);
    this.isChangePassword.set(false);
    this.passwordOld.set('');
    this.password.set('');
    this.passwordRepeat.set('');
    this.user_profile_collapse.set('');
    await this.userService.getUser();
  }
}
